import { useMemo, useState } from "react";
import { buildAlertsForPerson } from "../domain/buildAlertsForPersona";
import { LABELS } from "../domain/constants";

export function useNotificacionesViewModel(personas) {
    const [query, setQuery] = useState("");
    const [horizon, setHorizon] = useState(180);
    const [estado, setEstado] = useState("all");
    const [tipo, setTipo] = useState("all");
    const [groupByPerson, setGroupByPerson] = useState(true);
    const [sortBy, setSortBy] = useState("days");

    // Si no estás usando "ack", elimínalo del todo (ahora mismo lo tienes como Set fijo).
    const [ackIds] = useState(() => new Set());

    const alerts = useMemo(() => {
        const out = [];
        for (const p of personas) {
            const a = buildAlertsForPerson(p, Number(horizon));
            for (const x of a) out.push(x);
        }
        return out;
    }, [personas, horizon]);

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        const out = [];

        for (const a of alerts) {
            if (ackIds.has(a.id)) continue;

            const hayTexto =
                !q ||
                (a.personName || "").toLowerCase().includes(q) ||
                (a.label || "").toLowerCase().includes(q) ||
                (a.meta || "").toLowerCase().includes(q);
            if (!hayTexto) continue;

            const matchEstado =
                estado === "all" ||
                (estado === "expired" && a.status === "expired") ||
                (estado === "soon" && a.status === "soon") ||
                (estado === "missing" && a.status === "missing");
            if (!matchEstado) continue;

            if (tipo !== "all" && a.tipo !== tipo) continue;

            out.push(a);
        }

        out.sort((A, B) => {
            if (sortBy === "days") return (A.daysLeft ?? 9e6) - (B.daysLeft ?? 9e6);
            if (sortBy === "fecha") return String(A.fecha || "").localeCompare(String(B.fecha || ""));
            if (sortBy === "persona") return String(A.personName || "").localeCompare(String(B.personName || ""), "es");
            if (sortBy === "tipo") return String(LABELS[A.tipo] || A.tipo).localeCompare(String(LABELS[B.tipo] || B.tipo), "es");
            return 0;
        });

        return out;
    }, [alerts, query, estado, tipo, sortBy, ackIds]);

    const kpi = useMemo(() => {
        let cad = 0;
        let soon = 0;
        for (const a of filtered) {
            if (a.status === "expired") cad++;
            if (a.status === "soon") soon++;
        }
        return { total: filtered.length, cad, soon };
    }, [filtered]);

    const grouped = useMemo(() => {
        const map = new Map();
        for (const a of filtered) {
            if (!map.has(a.personId)) map.set(a.personId, { personId: a.personId, personName: a.personName, items: [] });
            map.get(a.personId).items.push(a);
        }
        return Array.from(map.values()).sort((A, B) => String(A.personName || "").localeCompare(String(B.personName || ""), "es"));
    }, [filtered]);

    return {
        // state
        query, setQuery,
        horizon, setHorizon,
        estado, setEstado,
        tipo, setTipo,
        groupByPerson, setGroupByPerson,
        sortBy, setSortBy,

        // data
        filtered,
        grouped,
        kpi,
    };
}
